/**
 * Shared constants for the deep-link "pending prompt" session-storage handoff.
 *
 * The pending prompt is written by `agentChatAguiStore.setPendingPrompt` (writer)
 * and consumed by the `useConsumePendingPrompt` hook (reader) after a page
 * reload/navigation. Both sides import from this module so the key and TTL
 * agree by construction.
 */

/**
 * Session-storage key used to persist a pending prompt across a page reload.
 */
export const PENDING_PROMPT_SESSION_KEY = 'otto:pendingPrompt';

/**
 * Max age (ms) for a session-storage-persisted pending prompt. Older entries
 * are treated as stale and dropped on read.
 */
export const PENDING_PROMPT_MAX_AGE_MS = 60_000;
